<div class="card-header" id="yearBreakdownsHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#yearBreakdownsCollapse" aria-expanded="true" aria-controls="yearBreakdownsCollapse">
        Occurences des pannes sur 12 mois glissants
    </button>
</div>

<div id="yearBreakdownsCollapse" class="panel-collapse collapse" aria-labelledby="yearBreakdownsHeader"
    data-parent="#accordionExtraction">
    <div class="card-body row">
        <div class="wrapper shadowed">
            <br>
            <button (click)="loadList()" class="btn btn-primary" style="margin-left: 40px;">Valider</button>
        </div>
        <br><br>
        <app-gmao-spinner *ngIf="loading"></app-gmao-spinner>

        <ng-container *ngIf="data">
            <div class="wrapper shadowed">
                <br />
                <h4>Résultats</h4>
                <app-export-button [data]="data"></app-export-button>
                <br />
            </div>
        </ng-container>
        <br />
    </div>
</div>